import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Map} from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {default as Facets, FacetItem} from 'components/Facets';
import {splitIconSets} from '../utils/records';

export default createReactClass({
  propTypes: {
    activeIds: ImmutablePropTypes.set.isRequired,
    iconSets: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
    icons: ImmutablePropTypes.iterableOf(ImmutablePropTypes.record).isRequired,
    workingSetIcons: ImmutablePropTypes.listOf(
      ImmutablePropTypes.record
    ).isRequired,
    iconSetIdsInSubscription: ImmutablePropTypes.listOf(
      PropTypes.number
    ).isRequired,
    countsFrom: ImmutablePropTypes.map,
    onSelect: PropTypes.func.isRequired,
    onDeselect: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  getDefaultProps() {
    return {
      countsFrom: Map(),
    };
  },

  handleFacetSelected(facetItem) {
    this.props.onSelect(facetItem.source.id);
  },

  handleFacetDeselected(facetItem) {
    this.props.onDeselect(facetItem.source.id);
  },

  render() {
    const {iconSets, icons, iconSetIdsInSubscription, workingSetIcons, countsFrom, activeIds} = this.props;

    const {availableUsed, availableNotUsed, unavailable} = splitIconSets(iconSets, icons, iconSetIdsInSubscription, workingSetIcons);
    const count = (countsFrom.isEmpty()) ? (iconSet) => iconSet.icons.size : (iconSet) => countsFrom.get(iconSet.id);
    const makeFacetItem = (iconSet) => {
      return FacetItem({
        source: iconSet,
        label: iconSet.name,
        selected: activeIds.has(iconSet.id),
        count: count(iconSet),
        tooltip: 'Show only',
      });
    };
    const availableUsedFacetItems = availableUsed.map(makeFacetItem);
    const availableNotUsedFacetItems = availableNotUsed.map(makeFacetItem);
    const unavailableFacetItems = unavailable.map(makeFacetItem);

    return (
      <Facets
        heading="Icon Sets"
        onFacetSelected={this.handleFacetSelected}
        onFacetDeselected={this.handleFacetDeselected}
        groups={Map({
          included: availableUsedFacetItems,
          available: availableNotUsedFacetItems,
          unavailable: unavailableFacetItems,
        })}
      />
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/AddIconsFacets.js